import { motion } from 'framer-motion';
import { useState } from 'react';
import {universities} from '../../model/universities-model';
import { Header } from '../../components/head';
import { Footer } from '../../components/footer';
import { TopHeader } from '../../components/top-header';
import { Helmet } from "react-helmet";

const UniversitiesList = () => {
  const [expandedIdx, setExpandedIdx] = useState(null);

  const toggleExpand = idx => {
    setExpandedIdx(prev => (prev === idx ? null : idx));
  };

  const styles = {
    page: {
      background: 'linear-gradient(180deg, #0b0e14 0%, #0f1420 100%)',
      minHeight: '100vh',
      color: '#e6eef7'
    },
    container: {
      maxWidth: 1100,
      margin: '0 auto',
      padding: '20px 16px'
    },
    title: {
      margin: '16px 0 4px',
      fontSize: 28,
      fontWeight: 800,
      textAlign: 'center',
      letterSpacing: 0.4
    },
    subtitle: {
      margin: '0 0 18px',
      fontSize: 14,
      textAlign: 'center',
      opacity: 0.85
    },
    list: {
      display: 'grid',
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
      gap: 16,
      background: "inherit"
    },
    card: {
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 12,
      padding: 16,
      boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
    },
    address: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: 8,
      marginTop: 8,
      marginBottom: 8
    },
    coursesTitle: {
      margin: '10px 0 6px',
      fontWeight: 700,
      color: '#8cd7ff'
    },
    applyWrap: {
      marginTop: 12
    },
    applyBtn: {
      background: 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
      color: '#fff',
      fontWeight: 800,
      borderRadius: 10,
      padding: '10px 18px',
      border: '1px solid #5ba0f2',
      cursor: 'pointer',
      boxShadow: '0 6px 16px rgba(74,144,226,0.35)'
    },
    arrow: {
      transition: 'transform 0.2s',
      display: 'flex',
      alignItems: 'center',
      marginLeft: '10px'
    },
    headerRow: {
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between',
      cursor:'pointer'
    }
  };

  return (
    <>
      <Helmet>
        <title>UNIVERSITIES | AIA</title>
        <meta name="description" content="Explore top universities in China and India with AIA. Find scholarships, admission guidance, and study abroad opportunities today." />
      </Helmet>
    <Header uniPg={true} />
      <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>List of Universities You Can Apply For</h1>
        <p style={styles.subtitle}>Tap a university to view details and available programs</p>
        <div className="universities-list" style={styles.list}>
        {universities.map((uni, idx) => (
          <motion.div
            className={`university-card${expandedIdx === idx ? ' expanded' : ''}`}
            key={uni.name}
            initial={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.5 + idx * 0.1 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.1 }}
            style={styles.card}
          >
            <div className="university-card-header" style={styles.headerRow} onClick={() => toggleExpand(idx)}>
              <h1 style={{margin:0}}>{uni.name}</h1>
              <span className="expand-arrow" style={{...styles.arrow, transform: expandedIdx === idx ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#00bfff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </span>
            </div>
            <address className="university-address" style={styles.address}>
              <p><strong>Country:</strong> {uni.country}</p>
              <p><strong>Province:</strong> {uni.province}</p>
              <p><strong>City:</strong> {uni.city}</p>
              <p><strong>District:</strong> {uni.district}</p>
            </address>
            {expandedIdx === idx && <>
              <p className="university-courses-title" style={styles.coursesTitle}>Courses</p>
              <ul className="university-courses">
                {uni.courses.degree && (
                  <div>
                    <h4>Degree Programs:</h4>
                    {uni.courses.degree.map((course, i) => (
                      <li key={`degree-${i}`} className='course-item'>
                        <strong>{course.course}</strong> - {course.duration} 
                        {course.fee && ` - ${course.fee}`}
                        {course.languageTaught && ` (${course.languageTaught}-taught)`} 
                      </li>
                    ))}
                  </div>
                )}
                {uni.courses.masters && (
                  <div>
                    <h4>Masters Programs:</h4>
                    {uni.courses.masters.map((course, i) => (
                      <li key={`masters-${i}`} className='course-item'>
                        <strong>{course.course}</strong> - {course.duration}
                        {course.fee && ` - ${course.fee}`}
                        {course.languageTaught && ` (${course.languageTaught}-taught)`}
                      </li>
                    ))}
                  </div>
                )}
              </ul>
              <div style={styles.applyWrap}>
                <center>
                  <a href="/aas/apply" target="_blank" rel="noopener noreferrer">
                    <button className="university-apply-btn" style={styles.applyBtn}>Apply now</button>
                  </a>
                </center>
              </div>
            </>}
          </motion.div>
        ))}
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default UniversitiesList;